import { store } from '@/state/store';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';

export function FN_GRAPH_UPDATE__node_remove__by_event(graph: DTO_GRAPH__instance) {
  let { g_graph__node_id_selected } = store.getState().slice_ui;

  if (!graph.nodes_map.has(g_graph__node_id_selected)) return false;

  let node = graph.node__get(g_graph__node_id_selected);

  if (!node.meta.is_deletable) return false;

  graph.node__delete(g_graph__node_id_selected);

  UTILS__graph_ui.node__deselect();

  return true; //need to update graph remotely
}
